<template>
  <v-list class="sidebar-list">
    <template v-for="item in items">
      <!-- Standard FIXED sidebar on larger windows -->
      <sub-menu-options
        v-if="!isMobile && item.children && !isMiniSidebar && activeRoute"
        :key="item.link"
        :current-route="activeRoute.name"
        :menu-options="item.children"
        @link-clicked="linkClicked"
      >
        <template v-slot:menu-title>
          <v-list-tile
            :key="item.link"
            ripple
            :to="{ name: item.link }"
            class="sidebar-link"
            :class="{ 'sidebar-active-link': activeRoute.name === item.link }"
            @click="linkClicked(item)"
          >
            <!-- Icon -->
            <v-list-tile-action v-if="!isMobile && item.icon">
              <v-icon class="mediumIcon">
                {{ item.icon }}
              </v-icon>
            </v-list-tile-action>
            <!-- Text -->
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </sub-menu-options>
      <!-- Mini sidebar -->
      <v-menu
        v-else-if="item.children && isMiniSidebar"
        :key="item.children.text"
        offset-x
      >
        <v-list-tile
          slot="activator"
          ripple
          class="sidebar-mini-link"
          :class="{ 'sidebar-active-link': activeRoute.name === item.link }"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon class="mediumIcon">
              {{ item.icon }}
            </v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-card>
          <!-- If the item has children. -->
          <template v-for="child in item.children">
            <!-- If the children have children. -->
            <v-menu
              v-if="child.children"
              :key="child.link"
              open-on-hover
              class="sidebar-link sidebar-submenu__link"
              full-width
              offset-x
            >
              <v-list-tile slot="activator" ripple>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ child.text }}
                    <v-icon small color="black" class="ml-5">
                      keyboard_arrow_right
                    </v-icon>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-card>
                <v-list-tile
                  v-for="subChild in child.children"
                  :key="subChild.text"
                  class="sidebar-link sidebar-submenu__link"
                  :to="{ name: subChild.link }"
                  :class="{
                    'sidebar-active-link': activeRoute.name === subChild.link
                  }"
                  @click="linkClicked"
                >
                  <v-list-tile-title>{{ subChild.text }}</v-list-tile-title>
                </v-list-tile>
              </v-card>
            </v-menu>
            <!-- If the children have no children. -->
            <v-list-tile
              v-else
              :key="child.link"
              class="sidebar-link sidebar-submenu__link"
              :to="{ name: child.link }"
              :class="{
                'sidebar-active-link': activeRoute.name === child.link
              }"
              @click="linkClicked"
            >
              <v-list-tile-title>{{ child.text }}</v-list-tile-title>
            </v-list-tile>
          </template>
        </v-card>
      </v-menu>
      <!-- Temporary sidebar displayed below medium window size. -->
      <v-list-tile
        v-else
        :key="item.text"
        ripple
        :to="{ name: item.link }"
        :class="{
          'sidebar-active-link': activeRoute.name === item.link,
          'sidebar-mini-link': isMiniSidebar,
          'sidebar-link': !isMiniSidebar
        }"
        @click="linkClicked"
      >
        <!-- Hide the icon on mobile. -->
        <v-list-tile-action v-if="!isMobile && item.icon">
          <v-icon class="mediumIcon">
            {{ item.icon }}
          </v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.text }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
    <div class="sidebar-signout">
      <v-list-tile
        v-show="isMobile"
        id="menuItemInviteBuyer1"
        :class="{
          'sidebar-mini-link': isMiniSidebar,
          'sidebar-link': !isMiniSidebar
        }"
        ripple
        @click="logout()"
      >
        <v-list-tile-content>
          <v-list-tile-title>SIGN OUT</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </div>
  </v-list>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import SubMenuOptions from '../../uiUtils/SubMenuOptions.vue'

export default {
  components: {
    SubMenuOptions
  },

  props: {
    items: {
      type: Array,
      default: () => []
    },
    isMiniSidebar: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('common', ['isMobile', 'searchObject']),
    ...mapState('home', ['activeRoute'])
  },

  watch: {
    $route(to, from) {
      // TODO: Refactor this
      if (
        !to.params.homeId &&
        !to.path.includes('favorites/') &&
        !to.path.includes('search/')
      ) {
        this.currentLinkHandler(to)
      }
    }
  },

  created() {
    this.linkClicked()
  },

  methods: {
    ...mapActions('common', ['profileLogout']),
    ...mapMutations('home', {
      setActiveRoute: 'SET_ACTIVE_ROUTE'
    }),

    ...mapMutations('common', {
      setSearchObjectData: 'SET_SEARCH_OBJECT_DATA',
      setSearchYOffset: 'SET_SEARCH_Y_OFFSET',
      setDrawerState: 'SET_DRAWER_STATE',
      refreshSearchObject: 'REFRESH_SEARCH_OBJECT',
      clearLastNewQuery: 'CLEAR_LAST_NEW_QUERY',
      setAddressInputValue: 'SET_ADDRESS_INPUT_VALUE',
      resetMultipleRequestedObject: 'RESET_MULTIPLE_REQUESTED_OBJECT',
      resetSearchTextParams: 'RESET_SEARCH_TEXT_PARAMS',
      setSearchResultPage: 'SET_SEARCH_RESULT_PAGE',
      refreshSearchPage: 'REFRESH_SEARCH_PAGE'
    }),

    ...mapMutations('client', {
      setAssignToClient: 'SET_ASSIGN_TO_CLIENT'
    }),

    linkClicked(item) {
      // TODO: Refactor this
      let routePath = this.$router.currentRoute
      if (
        routePath &&
        routePath.name !== 'agent-search' &&
        routePath.name !== 'client-search'
      ) {
        this.resetData()
      }
      // if (
      //   routePath &&
      //   routePath.name === 'agent-search' &&
      //   this.searchObject.searchResult
      // ) {
      //   this.resetData()
      //   this.setSearchResultPage(false)
      //   this.refreshSearchPage(true)
      // }
      if (
        !routePath.params.homeId &&
        !routePath.path.includes('favorites/') &&
        !routePath.path.includes('search/')
      ) {
        if (
          this.$router.currentRoute.name === this.activeRoute.name &&
          this.isMobile
        ) {
          this.setDrawerState(false)
        }
        this.currentLinkHandler(routePath)
      }
    },

    resetData() {
      this.setSearchYOffset(0)
      this.setSearchObjectData([])
      this.refreshSearchObject()
      this.clearLastNewQuery()
      this.setAddressInputValue({ text: '', suggestion: false })
      this.resetMultipleRequestedObject()
      this.resetSearchTextParams()
      this.setAssignToClient({})
    },

    currentLinkHandler(routePath) {
      this.setActiveRoute(routePath)
      this.$router.push({ name: routePath.name })
    },

    logout() {
      this.profileLogout()
    }
  }
}
</script>

<style lang="sass">
.sidebar-link .v-list__tile__action, .v-list__tile__avatar
  min-width: 40px !important

.sidebar-list
  .sidebar-link
    .v-list__tile__title
      font-size: 12px
  .sidebar-active-link, .sidebar-link:hover
    background: $hwayzBrandBlue !important
    .v-list__tile__title
      color: $hwayzWhite !important
      font-family: Roboto,sans-serif
    i
      color: $hwayzWhite !important

.sidebar-link .v-list__tile__action, .v-list__tile__avatar
  min-width: 40px !important

.v-list
  padding-bottom: 0 !important

.sidebar-signout
  margin-top: 5rem
  padding: 1.5rem 0rem !important
  @media only screen and (max-width: 450px)
    margin-top: 4rem
    padding: 1rem 0 !important
  @media only screen and (min-width: 600px)
    padding: 2rem 0.5rem !important
  @media only screen and (min-width: 960px)
    padding: 2rem 1rem !important
</style>
